export default __webpack_public_path__ + "static/media/weather-dashboard1-screenshot.9ce81035.png";